// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"120":"5198ad72","856":"b71d8a9c","935":"a351177c"}[chunkId] + ".js";
};